import { rect, cRect, cSpine, mRect, CENTER } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

export const hull_dreadnought: Hull = {
  id: 'hull_dreadnought',
  name: 'Dreadnought',
  drawBody: (ctx, p) => {
    cRect(ctx, 20, 4, 1, p.primary); cRect(ctx, 21, 6, 1, p.primary); cRect(ctx, 22, 8, 2, p.primary);
    cRect(ctx, 24, 14, 16, p.primary);
    cRect(ctx, 24, 14, 1, p.light); rect(ctx, CENTER - 7, 24, 1, 16, p.light); rect(ctx, CENTER + 6, 24, 1, 16, p.shadow); cRect(ctx, 39, 14, 1, p.shadow);
    cRect(ctx, 28, 14, 1, p.shadow); cRect(ctx, 34, 14, 1, p.shadow); cSpine(ctx, 25, 14, p.shadow);
    mRect(ctx, 4, 30, 2, 1, p.accentDark); mRect(ctx, 4, 36, 2, 1, p.accentDark);
    cRect(ctx, 40, 12, 1, p.dark); cRect(ctx, 20, 4, 1, p.light);
  },
  mounts: {
    [SLOT.COCKPIT]:    { anchor: { x: 32, y: 26 }, cap: (ctx, p) => cRect(ctx, 28, 6, 1, p.dark) },
    [SLOT.WING_L]:     { anchor: { x: 24, y: 32 }, cap: (ctx, p) => { rect(ctx, 23, 31, 3, 4, p.shadow); rect(ctx, 23, 31, 3, 1, p.dark); rect(ctx, 23, 31, 1, 4, p.dark); } },
    [SLOT.WING_R]:     { anchor: { x: 39, y: 32 }, cap: (ctx, p) => { rect(ctx, 38, 31, 3, 4, p.shadow); rect(ctx, 38, 31, 3, 1, p.dark); rect(ctx, 40, 31, 1, 4, p.dark); } },
    [SLOT.ENGINE_L]:   { anchor: { x: 27, y: 40 }, cap: (ctx, p) => { rect(ctx, 25, 39, 5, 2, p.shadow); rect(ctx, 25, 39, 5, 1, p.dark); } },
    [SLOT.ENGINE_R]:   { anchor: { x: 37, y: 40 }, cap: (ctx, p) => { rect(ctx, 34, 39, 5, 2, p.shadow); rect(ctx, 34, 39, 5, 1, p.dark); } },
    [SLOT.WEAPON_TOP]: { anchor: { x: 32, y: 23 }, base: (ctx, p) => { cRect(ctx, 24, 6, 1, p.metal); cRect(ctx, 23, 4, 1, p.metalDark); } },
    [SLOT.NOSE]:       { anchor: { x: 32, y: 20 } },
  },
};
